import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "vc-incoming-hero" }
const _hoisted_2 = { class: "vc-incoming-hero__title text-wrap" }
const _hoisted_3 = { class: "vc-incoming-hero__purpose text-wrap" }
const _hoisted_4 = { class: "vc-incoming-hero__connecting" }
const _hoisted_5 = { class: "mb-16" }

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useCallStore } from '../stores/callStore'
import { apiClient } from '../services/apiClient'
import { signalingService } from '../services/signalingService'
import PatientBackground from '../components/PatientBackground.vue'
import { breakthroughPrimaryLine, breakthroughSecondaryLine } from '@virtual-care/shared'
import type { SessionCredentials } from '@virtual-care/shared'


export default /*@__PURE__*/_defineComponent({
  __name: 'BreakthroughCallView',
  setup(__props) {

const router = useRouter()
const callStore = useCallStore()

const primaryLine = breakthroughPrimaryLine()
const secondaryLine = breakthroughSecondaryLine()

onMounted(async () => {
  const sessionId = callStore.sessionId
  const roomId = apiClient.getRoomId()
  
  if (!sessionId) {
    router.replace('/')
    return
  }

  try {
    // Join session to get provider and credentials (same as normal call flow)
    const joinResponse = await apiClient.joinSession(sessionId, 'patient')

    console.log('[BreakthroughCallView] Joined session', {
      provider: joinResponse.session?.provider,
      hasCredentials: !!joinResponse.session?.credentials
    })

    const provider = joinResponse.session?.provider
    if (!provider) {
      throw new Error('No video provider returned from backend')
    }
    
    const credentials = joinResponse.session?.credentials

    // Store provider and credentials in callStore (critical for correct video client!)
    callStore.acceptCall(
      provider as never,
      credentials as SessionCredentials | undefined
    )

    // Notify nurse that patient has connected (sends call_accepted event)
    signalingService.notifyCallAccepted(sessionId, roomId)

    // Navigate to active call view
    router.replace(`/call/${sessionId}`)
  } catch (error) {
    console.error('[BreakthroughCallView] Failed to join session:', error)
    callStore.endCall()
    router.replace('/')
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0 fill-height bg-backgroundBase vc-incoming-root vc-tv-canvas-bg"
  }, {
    default: _withCtx(() => [
      _createVNode(PatientBackground),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(primaryLine)), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(secondaryLine)), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_progress_circular, {
            color: "primary",
            indeterminate: "",
            size: "48",
            width: "4"
          })
        ])
      ]),
      _createVNode(_component_v_sheet, {
        class: "vc-incoming-panel vc-connecting-panel d-flex flex-column bg-white",
        elevation: "24",
        height: "100%",
        rounded: "0"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_icon, {
              class: "vc-rail__video-icon",
              color: "primary"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-video-plus-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", {
            class: "flex-grow-1",
            "aria-hidden": "true"
          }, null, -1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})